import type { ReactNode } from "react";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  action?: ReactNode;
  align?: "left" | "center";
  id?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  action,
  align = "left",
  id,
}: SectionHeadingProps) {
  const alignment = align === "center" ? "items-center text-center" : "items-start text-left";

  return (
    <div
      className={`flex flex-col gap-4 md:flex-row md:items-end md:justify-between ${
        align === "center" ? "md:flex-col md:items-center" : ""
      }`}
    >
      <div className={`flex flex-col ${alignment} max-w-2xl`}>
        {eyebrow && (
          <span className="inline-flex items-center gap-2 text-xs font-label tracking-[0.2em] uppercase text-primary-700">
            <span className="w-5 h-px bg-primary-500"></span>
            {eyebrow}
          </span>
        )}
        <h2
          id={id}
          className="mt-3 font-heading font-bold text-2xl md:text-3xl text-foreground-950 text-balance"
        >
          {title}
        </h2>
        {description && (
          <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">
            {description}
          </p>
        )}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}